import React from "react";
import ContactPageForm from "./ContactPageForm";
import ContactPageMap from "./ContactPageMap";
import ContactPageHeader from "./ContactPageHeader";
import SocialCards from "./SocialCards";

const MainContactPage = () => {
  return (
    <div>
      <ContactPageHeader />
      <ContactPageForm />
      <ContactPageMap />
      <SocialCards />
    </div>
  );
};

export default MainContactPage;
